import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { List as List$1 } from '@zillow/zrs-cms';
import { generateBlockList } from '../../components/BlockList/BlockList.js';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';

var _excluded = ["margin"];
var BlockList = function BlockList(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index,
    innerBlocks = _ref.innerBlocks;
  var isPost = usePlacement() === 'post';
  var _attrs$margin = attrs.margin,
    margin = _attrs$margin === void 0 ? {} : _attrs$margin,
    rest = _objectWithoutProperties(attrs, _excluded);
  var marginTop = Object.assign({
    default: 'none',
    lg_lte: 'none',
    sm_lte: 'none'
  }, margin === null || margin === void 0 ? void 0 : margin.marginTop);
  var marginBottom = Object.assign({
    default: 'none',
    lg_lte: 'none',
    sm_lte: 'none'
  }, margin === null || margin === void 0 ? void 0 : margin.marginBottom);
  return /*#__PURE__*/React.createElement(List$1, _extends({
    key: index
  }, rest, !isPost && {
    marginBottom: marginBottom,
    marginTop: marginTop
  }, isPost && {
    paddingBottom: 'sm'
  }), generateBlockList({
    blocks: innerBlocks
  }));
};
BlockList.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({}),
  index: PropTypes.number,
  innerBlocks: PropTypes.arrayOf(PropTypes.shape({}))
} : {};
var List = BlockList;

export { List as default };
